export default __webpack_public_path__ + "static/media/imagem_08.e1915bdd.jpg";